import React from "react";
import SkeletonData from "../data";

const SkeletonRow = ({
  columnLength = 8,
  height = "56px",
  paddingX = "13px",
  className = null,
  withBlankFirstRow = false,
}) => {
  return (
    <tr className={className}>
      {withBlankFirstRow && (
        <td
          style={{ height, paddingLeft: paddingX, paddingRight: paddingX }}
        ></td>
      )}
      {Array.from({ length: columnLength }).map((_, index) => (
        <SkeletonData
          key={`skeleton-data-${index}`}
          height={height}
          paddingX={paddingX}
        />
      ))}
    </tr>
  );
};

export default SkeletonRow;
